import { useState } from "react";
import { NavLink } from "react-router-dom";
import { Lock, X, Menu } from "lucide-react";

export default function Sidebar({ menuItems }) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <>
      {/* Sidebar */}
      <aside
        className={`bg-white shadow-xl w-64 flex-shrink-0 p-6 space-y-6 fixed top-0 left-0 h-screen z-50 transform ${
          mobileMenuOpen ? "translate-x-0" : "-translate-x-full"
        } transition-transform duration-300 md:translate-x-0`}
      >
        {/* Logo */}
        <div className="text-cyan-700 font-bold text-xl tracking-tight">
          <div className="flex items-center gap-2">
            <Lock className="w-6 h-6" />
            <span>SecurePass</span>
          </div>
          <p className="ml-8 text-sm font-medium text-gray-500">Generator</p>
        </div>

        {/* Navigation */}
        <nav className="flex flex-col gap-2 text-gray-700 font-medium">
          {menuItems.map((item, i) => (
            <NavLink
              key={i}
              to={item.path}
              className={({ isActive }) =>
                `flex items-center gap-3 py-2 px-3 rounded-lg w-full text-left transition
                ${isActive ? "bg-cyan-100 text-cyan-700" : "hover:bg-cyan-50 hover:text-cyan-700"}`
              }
            >
              <item.icon className="w-5 h-5" />
              {item.label}
            </NavLink>
          ))}
        </nav>

        {/* Footer */}
        <div className="absolute bottom-4 w-full text-center text-gray-400 text-xs">
          v1.0.0
        </div>
      </aside>

      {/* Mobile toggle */}
      <button
        className="fixed top-4 left-4 md:hidden z-50 p-2 bg-white rounded-md shadow focus:ring-2 focus:ring-cyan-500"
        onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        aria-label="Toggle Menu"
      >
        {mobileMenuOpen ? <X /> : <Menu />}
      </button>
    </>
  );
}
